var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _vm.configList.length > 1 ? _c('permission-manager', { attrs: { "latchkey": "add-json-category-config" } }, [_c('el-button', { staticClass: "remove-json-category-config", attrs: { "type": "text" }, on: { "click": _vm.remove } }, [_c('svg-icon', { attrs: { "icon-class": "trash", "size": 24 } })], 1)], 1) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };